import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  Autocomplete,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const MuiAutoCompleteSmall = (props) => {
  const {
    options,
    label,
    isDisabled,
    handleInputChange,
    name,
    control,
    disabled,
    defaultValue,
    errorFlag,
  } = props;

  return (
    <div className="w-full">
      <Controller
        render={({ field, value }) => (
          <Autocomplete
            {...field}
            options={options}
            sx={{
              width: "100%",
              height: "13px",
              "& .MuiAutocomplete-popupIndicator": { transform: "none" },
              "& .MuiAutocomplete-inputRoot": {
                padding: 0,
                height: "30px",
              },
            }}
            size="small"
            popupIcon={<SearchIcon />}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                size="small"
                error={errorFlag}
              />
            )}
            getOptionLabel={(option) => (option.label ? option.label : "")}
            disabled={disabled ? disabled : false}
            onChange={(_, data) => field.onChange(data)}
            // onInputChange={(event, newInputValue) => {
            //
            //    handleInputChangeHandlerTechnician(newInputValue);
            // }}

            onInputChange={(_, data) => {
              if (data !== " ") {
                handleInputChange(data);
              }
            }}
            value={field.value}
            defaultValue={defaultValue}
          />
        )}
        name={name}
        control={control}
      />
    </div>
  );
};

export default MuiAutoCompleteSmall;
